import angular from 'angular'

import { isZero } from './bits'
import { delFromArray } from './arrayh'
import { wrap, includes } from 'lodash-es'

import MapSimple from './map-simple'

angular
  .module('ggs.utils')
  .factory('IdleChannel', IdleChannelProvider)

function IdleChannelProvider($q, qh, waitFor) {
  const name2channel = MapSimple()

  const nextRegId = NextId()
  const nextLinkId = NextId()
  const nextChannelId = NextId()

  IdleChannel.waitOnIdle = waitOnIdle
  IdleChannel.getTasksCount = getTasksCount

  return IdleChannel

  function getTasksCount() {
    let sum = 0
    const channels = name2channel.values()
    for (const channel of channels) {
      sum += channel.regs.length
    }
    return sum
  }

  function waitOnIdle() {
    return waitFor(getTasksCount, isZero)
  }

  function IdleChannel(name) {
    const linkId = nextLinkId()
    const channel = name2channel.has(name)
      ? name2channel.get(name)
      : name2channel.set(name, Channel(name))

    return {
      queue,
      cancel,
      cancelAll
    }

    function find(action) {
      for (const reg of channel.regs) {
        if (reg.linkId === linkId && reg.action === action) {
          return reg
        }
      }
      return null
    }

    function queue(action) {
      const deferred = $q.defer()
      const reg = Reg(linkId, action, deferred)
      channel.regs.push(reg)
      check(channel)
      deferred.promise.cancel = wrap(reg, cancelByReg)
      return deferred.promise
    }

    function cancel(action) {
      const reg = find(action)
      if (reg) {
        cancelByReg(reg)
      }
    }

    function cancelAll() {
      const regs = []
      for (const reg of channel.regs) {
        if (reg.linkId === linkId) {
          regs.push(reg)
        }
      }

      for (const reg of regs) {
        cancelByReg(reg)
      }
    }

    function cancelByReg(reg) {
      if (includes(channel.regs, reg)) {
        delFromArray(channel.regs, reg)
        check(channel)
        reg.deferred.reject(qh.markCanceled(new Error(`IdleChannel[name=${name}] - task has been canceled!`)))
      }
    }
  }

  function Channel(name) {
    return {
      id: nextChannelId(),
      name,
      regs: [],
      idle: null
    }
  }

  function Reg(linkId, action, deferred) {
    return {
      id: nextRegId(),
      linkId,
      action,
      deferred
    }
  }

  function check(channel) {
    if (channel.regs.length !== 0 && channel.idle === null) {
      channel.idle = requestIdleCallback(wrap(channel, flush))
    } else if (channel.regs.length === 0 && channel.idle !== null) {
      cancelIdleCallback(channel.idle)
      channel.idle = null
    }
  }

  function flush(channel) {
    const local = channel.regs.concat()
    channel.regs.length = 0
    channel.idle = null
    for (const reg of local) {
      reg.deferred.resolve(reg.action())
    }
  }

  function NextId() {
    let count = 0
    return function nextId() {
      return count++
    }
  }
}
